import { FormattedMessage, useIntl } from 'react-intl';
import { useFormContext } from 'react-hook-form';
import { FormAutocompleteMultiple, FormAutocompleteMultipleProps } from './formAutocompleteMultiple';
import { getUsStates } from '../../../libs/maps/getUsStates';

const statesOptions = getUsStates().map((state) => {
  return {
    value: state.value,
    label: state.label,
  };
});

type StatesSelectProps = Omit<FormAutocompleteMultipleProps<string[]>, 'options' | 'name'>;
export function FormStatesSelect(props: StatesSelectProps) {
  const intl = useIntl();
  const { watch } = useFormContext<{ statesOfService: string[] | undefined }>();
  const selectedLineOfBusiness = watch('statesOfService');
  const selectedNumber = selectedLineOfBusiness?.length ?? 0;

  return (
    <FormAutocompleteMultiple
      options={statesOptions}
      label={<FormattedMessage id="fields.statesOfService" />}
      textFieldProps={{
        placeholder:
          selectedNumber === 0
            ? intl.formatMessage({
                id: 'fields.statesOfService',
              })
            : undefined,
      }}
      disableCloseOnSelect
      name="statesOfService"
      requiredMessage={intl.formatMessage({
        id: 'forms.emptyStatesOfService',
      })}
      {...props}
    />
  );
}


